import React from 'react';
import Table from '../table/redux/Table';
import { finalRiskApi } from '../apis';
import Has from '../auth/Has';
import { CAN_ADD_FINAL_RISK_OVERRIDE_REASON } from '../auth/permissions';
import { AddFinalRiskOverrideReasonsModal } from './AddFinalRiskOverrideReasonModal';
import { InternalApiFinalRiskOverrideReason } from '../api-internal';
import { Button } from '@salvapp/ui-components';
import { EditFinalRiskOverrideReasonModal } from './EditFinalRiskOverrideReasonModal';
import { useDispatch } from 'react-redux';
import { setRefresh } from '../table/redux/tablesReducer';
import { Dispatch } from 'redux';
import SalvPage from '../common/SalvPage';
import { getConfigurationUrl } from '../navigation/helper';
import { ConfigurationProduct } from '../settings/configuration/Configuration';

const fetchReasons = async (page: number, size: number) => {
  return finalRiskApi.findAllOverrideReasons({ page, size });
};

const fetchArchivedReasons = async (page: number, size: number) => {
  return finalRiskApi.findArchivedOverrideReasons({ page, size });
};

const restoreFromArchive = (handle: string, dispatch: Dispatch) => {
  finalRiskApi
    .restoreOverrideReason({ handle })
    .then(() => {
      dispatch(setRefresh({ name: 'riskOverrideReasons', shouldRefresh: true }));
      dispatch(setRefresh({ name: 'archivedRiskOverrideReasons', shouldRefresh: true }));
    })
    .catch(() => null);
};

const tableHeader = () => (
  <tr>
    <th className='col-5'>Reason</th>
    <th className='col-5'>Description</th>
    <th className='col text-end'>Actions</th>
  </tr>
);

export const FinalRiskOverrideReasons = () => {
  const dispatch = useDispatch();
  return (
    <SalvPage
      title={'Risk override reasons'}
      breadcrumb={{
        title: 'Configuration',
        to: getConfigurationUrl(ConfigurationProduct.RISK),
      }}
    >
      <Table<InternalApiFinalRiskOverrideReason>
        title='Active reasons'
        hover={false}
        name='riskOverrideReasons'
        fetchContent={fetchReasons}
        header={tableHeader}
        actions={() => (
          <Has allPermissions={CAN_ADD_FINAL_RISK_OVERRIDE_REASON}>
            <AddFinalRiskOverrideReasonsModal />
          </Has>
        )}
        body={(reasons) =>
          reasons.length > 0 &&
          reasons.map((reason) => (
            <tr key={reason.handle}>
              <td className='col-5'>{reason.reason}</td>
              <td className='col-5'>{reason.description}</td>
              <td className='col text-end'>
                <Has allPermissions={CAN_ADD_FINAL_RISK_OVERRIDE_REASON}>
                  <EditFinalRiskOverrideReasonModal
                    overrideReasonHandle={reason.handle}
                    reason={reason.reason}
                    description={reason.description}
                  />
                </Has>
              </td>
            </tr>
          ))
        }
      />
      <Table<InternalApiFinalRiskOverrideReason>
        className='border-collapse'
        title='Archived reasons'
        hover={false}
        name='archivedRiskOverrideReasons'
        fetchContent={fetchArchivedReasons}
        header={tableHeader}
        body={(reasons) =>
          reasons.length > 0 &&
          reasons.map((reason) => (
            <tr key={reason.handle}>
              <td className='col-5'>{reason.reason}</td>
              <td className='col-5'>{reason.description}</td>
              <td className='col text-end'>
                <Has allPermissions={CAN_ADD_FINAL_RISK_OVERRIDE_REASON}>
                  <Button variant='outline-secondary' onClick={() => restoreFromArchive(reason.handle, dispatch)}>
                    Restore
                  </Button>
                </Has>
              </td>
            </tr>
          ))
        }
      />
    </SalvPage>
  );
};
